"use strict";

exports.__esModule = true;
exports.PROVIDER_TITLE_TRANSLATION_KEYS = exports.SHARE_BUTTON_TRANSLATION_KEYS = exports.getAllSocialSharingProviders = exports.SOCIAL_SHARING_LINK = exports.SOCIAL_SHARING_LINKED_IN = exports.SOCIAL_SHARING_TWITTER = exports.SOCIAL_SHARING_FACEBOOK = void 0;

var _lodash = require("lodash");

var _SHARE_BUTTON_TRANSLA, _PROVIDER_TITLE_TRANS;

var SOCIAL_SHARING_FACEBOOK = 'facebook';
exports.SOCIAL_SHARING_FACEBOOK = SOCIAL_SHARING_FACEBOOK;
var SOCIAL_SHARING_TWITTER = 'twitter';
exports.SOCIAL_SHARING_TWITTER = SOCIAL_SHARING_TWITTER;
var SOCIAL_SHARING_LINKED_IN = 'linked-in';
exports.SOCIAL_SHARING_LINKED_IN = SOCIAL_SHARING_LINKED_IN;
var SOCIAL_SHARING_LINK = 'link';
exports.SOCIAL_SHARING_LINK = SOCIAL_SHARING_LINK;

var getAllSocialSharingProviders = function getAllSocialSharingProviders(isShareOnLinkedInExperimentEnabled) {
  return (0, _lodash.compact)([SOCIAL_SHARING_FACEBOOK, SOCIAL_SHARING_TWITTER, isShareOnLinkedInExperimentEnabled && SOCIAL_SHARING_LINKED_IN, SOCIAL_SHARING_LINK]);
};

exports.getAllSocialSharingProviders = getAllSocialSharingProviders;
var SHARE_BUTTON_TRANSLATION_KEYS = (_SHARE_BUTTON_TRANSLA = {}, _SHARE_BUTTON_TRANSLA[SOCIAL_SHARING_FACEBOOK] = 'share-button.via-facebook', _SHARE_BUTTON_TRANSLA[SOCIAL_SHARING_TWITTER] = 'share-button.via-twitter', _SHARE_BUTTON_TRANSLA[SOCIAL_SHARING_LINKED_IN] = 'share-button.via-linked-in', _SHARE_BUTTON_TRANSLA[SOCIAL_SHARING_LINK] = 'share-button.via-link', _SHARE_BUTTON_TRANSLA);
exports.SHARE_BUTTON_TRANSLATION_KEYS = SHARE_BUTTON_TRANSLATION_KEYS;
var PROVIDER_TITLE_TRANSLATION_KEYS = (_PROVIDER_TITLE_TRANS = {}, _PROVIDER_TITLE_TRANS[SOCIAL_SHARING_FACEBOOK] = 'social-sharing.facebook', _PROVIDER_TITLE_TRANS[SOCIAL_SHARING_TWITTER] = 'social-sharing.twitter', _PROVIDER_TITLE_TRANS[SOCIAL_SHARING_LINKED_IN] = 'social-sharing.linked-in', _PROVIDER_TITLE_TRANS[SOCIAL_SHARING_LINK] = 'social-sharing.link', _PROVIDER_TITLE_TRANS);
exports.PROVIDER_TITLE_TRANSLATION_KEYS = PROVIDER_TITLE_TRANSLATION_KEYS;